import script from "./FaqsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaqsPage.vue?vue&type=script&setup=true&lang=ts"

import "./FaqsPage.vue?vue&type=style&index=0&id=f7df5186&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7df5186"]])

export default __exports__